import { hd250base64 } from './hd250.base64';
import { hd650base64 } from './hd650.base64';
import { hd1500base64 } from './hd1500.base64';
import { hd3500base64 } from './hd3500.base64';
import { aclogo } from './aclogo.base64';

export default {
	getAClogo() {
		return {
			image: aclogo
		}
	},
	getUnitList() {
		return [
			{
				"Model": "HD250",
				"Image": hd250base64,
				"Fluid": {
					"Flow": 0.25,
					"Temperature": 413.15,
					"Pressure": 900000,
					"Humidity": 0
				},
				"Coolant": {
					"GlycolType": "Ethylene",
					"GlycolContent": 0,
					"InputType": "Flow",
					"Flow": 0.0005,
					"DeltaT": 25,
					"Temperature": 298.15,
					"Pressure": 400000
				}
			},
			{
				"Model": "HD650",
				"Image": hd650base64,
				"Fluid": {
					"Flow": 0.65,
					"Temperature": 413.15,
					"Pressure": 900000,
					"Humidity": 0
				},
				"Coolant": {
					"GlycolType": "Ethylene",
					"GlycolContent": 0.0,
					"InputType": "Flow",
					"Flow": 0.0013,
					"DeltaT": 25,
					"Temperature": 298.15,
					"Pressure": 400000.0
				}
			},
			{
				"Model": "HD1500",
				"Image": hd1500base64,
				"Fluid": {
					"Flow": 1.5,
					"Temperature": 413.15,
					"Pressure": 900000.0,
					"Humidity": 0
				},
				"Coolant": {
					"GlycolType": "Ethylene",
					"GlycolContent": 0.0,
					"InputType": "Flow",
					"Flow": 0.003,
					"DeltaT": 25,
					"Temperature": 298.15,
					"Pressure": 400000.0
				}
			},
			{
				"Model": "HD3500",
				"Image": hd3500base64,
				"Fluid": {
					"Flow": 3.5,
					"Temperature": 413.15,
					"Pressure": 900000,
					"Humidity": 0
				},
				"Coolant": {
					"GlycolType": "Ethylene",
					"GlycolContent": 0.0,
					"InputType": "Flow",
					"Flow": 0.0013,
					"DeltaT": 25,
					"Temperature": 298.15,
					"Pressure": 400000
				}
			}
		]
	}
}


// WEBPACK FOOTER //
// ./src/units/data.unitlist.js